const PREFIX = "checkoutHold:";

/** Persist active pickup hold so a browser reload does not create a duplicate hold. */
export function writeCheckoutHoldSession(restaurantId, hold) {
  if (!restaurantId || !hold?.holdOrderId) return;
  try {
    sessionStorage.setItem(
      `${PREFIX}${restaurantId}`,
      JSON.stringify({
        holdOrderId: String(hold.holdOrderId),
        pickupWindow: hold.pickupWindow || "",
        pickupDate: hold.pickupDate || "",
        holdExpiresAt: hold.holdExpiresAt || null,
        tokenNumber: hold.tokenNumber || null,
      }),
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function readCheckoutHoldSession(restaurantId) {
  if (!restaurantId) return null;
  try {
    const raw = sessionStorage.getItem(`${PREFIX}${restaurantId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.holdOrderId) return null;
    const exp = parsed.holdExpiresAt ? new Date(parsed.holdExpiresAt).getTime() : 0;
    if (exp && exp <= Date.now()) {
      clearCheckoutHoldSession(restaurantId);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearCheckoutHoldSession(restaurantId) {
  if (!restaurantId) return;
  try {
    sessionStorage.removeItem(`${PREFIX}${restaurantId}`);
  } catch {
    /* ignore */
  }
}
